module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sharedcomponents/messagecenter/message-detail/message-detail.component.css
// module id = ./src/app/sharedcomponents/messagecenter/message-detail/message-detail.component.css
// module chunks = main